export default "__VITE_ASSET__f4034f0d__"